import { ref } from 'vue';
import { defineStore } from 'pinia';

// Which view "Hoy" opens with: the shifts list or the summary with the live map.
export const useTodayViewStore = defineStore('todayView', () => {
  const showSummary = ref(false);

  return { showSummary };
}, { persist: true });
